export default "__VITE_ASSET__D_ff48AT__"